import { useMutation, useQueryClient } from '@tanstack/react-query';

import { useToasts } from '../../../cdl/Toast/useToasts';
import { updateSupplierDetails } from '../../../common/api/clients/company.api';
import { queries } from '../../../common/api/queryKeys/queries';
import { translate } from '../../../common/helpers/translate.helper';

export const useSupplierDetailsEdit = () => {
    const queryClient = useQueryClient();
    const { addToast, addErrorToast } = useToasts();
    return useMutation({
        mutationFn: updateSupplierDetails,
        onSuccess: (data) => {
            queryClient.invalidateQueries({ queryKey: queries.suppliers.detail(data.id).queryKey });
            addToast(translate('company.toasts.informationUpdateSuccess'));
        },
        onError: () => {
            addErrorToast(translate('company.toasts.informationUpdateError'));
        },
    });
};
